import { useEffect } from "react";

import IndexRouters from "./router/index";

import "shepherd.js/dist/css/shepherd.css";
import "flatpickr/dist/flatpickr.css";
import "choices.js/public/assets/styles/choices.min.css";
import "./assets/scss/hope-ui.scss";
import "./assets/scss/pro.scss";
import "./assets/scss/custom.scss";
import "./assets/scss/dark.scss";
import "./assets/scss/rtl.scss";
import "./assets/scss/customizer.scss";
import "./assets/custom/scss/custom.scss";

import "./App.css";

import { useDispatch } from "react-redux";

import { setSetting } from "./store/setting/actions";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSetting());
  }, [dispatch]);

  return (
    <div className="App">
      <IndexRouters />
    </div>
  );
}

export default App;
